// Data constants - no JSX, won't trigger babel plugin
export const SCIENTIFIC_SKILLS = [
  "Drug Discovery", "Molecular Biology", "Clinical Research", 
  "Regulatory Affairs", "Bioinformatics", "Cell & Gene Therapy"
];

export const COMMERCIAL_SKILLS = [
  "Business Development", "Fundraising", "Sales & Marketing", 
  "Operations", "Financial Planning", "Legal & IP"
];

export const MOTIVATIONS = [
  { id: "impact", label: "Make meaningful patient impact" },
  { id: "science", label: "Translate research to applications" },
  { id: "autonomy", label: "Be my own boss" },
  { id: "wealth", label: "Create wealth" },
  { id: "challenge", label: "New intellectual challenge" },
  { id: "opportunity", label: "Spotted a market opportunity" }
];

export const VENTURE_BUILDERS = [
  { id: "dsv", name: "Deep Science Ventures", location: "London", focus: ["Life Sciences"], funding: "Up to £250k", url: "https://deepscienceventures.com", desc: "Scientific challenges" },
  { id: "zinc", name: "Zinc", location: "London", focus: ["Health"], funding: "Up to £100k", url: "https://zinc.vc", desc: "Mission-driven" },
  { id: "ef", name: "Entrepreneur First", location: "London", focus: ["Tech"], funding: "Up to £80k", url: "https://joinef.com", desc: "Find cofounders" }
];

export const ACCELERATORS = [
  { id: "babraham", name: "Babraham", location: "Cambridge", focus: ["Life Sciences"], funding: "£100k + Lab", url: "https://babraham.com", desc: "Lab space" },
  { id: "yc", name: "Y Combinator", location: "SF", focus: ["Biotech"], funding: "$500k", url: "https://ycombinator.com", desc: "YC Bio" }
];

export const INCUBATORS = [
  { id: "sbc", name: "SBC", location: "Stevenage", focus: ["Biotech"], funding: "Free Labs", url: "https://stevenagecatalyst.com", desc: "Open innovation" },
  { id: "biocity", name: "BioCity", location: "Nottingham", focus: ["Life Sciences"], funding: "Subsidized", url: "https://biocity.co.uk", desc: "Incubator network" }
];
